const domainWorkerTypeRuleEn = {
  common: {
    workerType: {
      // TODO: common.workerType に統一したい
      EMPLOYEE: "Employee",
      BOARD_MEMBER: "Board Member",
      CONTRACTOR: "Contractor",
      COLLABORATOR: "Collaborator",
    },
  },
  ruleHeader: {
    title: "Worker Type",
    description:
      "You can set rules for each employee or contractor. It is also possible to configure settings by specifying departments or job roles.",
  },
  individualHeader: {
    title: "Individual",
    description:
      "You can set rules for individuals when specifying privileged administrators separately or excluding them individually from the rules specified above.",
  },
  individualCondition: {
    include: "Include",
    includeNone: "-",
    exclude: "Exclude",
    excludeNone: "-",
  },
  ruleAccordionRadioButtonGroup: {
    settingType: {
      ALL: "Assign to all",
      NO_ONE: "Assign to no one",
      CUSTOM: "Custom Rule",
    },
  },
};

export default domainWorkerTypeRuleEn;
